<script lang="ts">
  import { onMount } from "svelte";

  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { initDetail } from "./lead.store"; 
import LeadDetailPartActivities from "./LeadDetailPartActivities.svelte";
import LeadDetailPartChannels from "./LeadDetailPartChannels.svelte";
import LeadDetailPartGeneral from "./LeadDetailPartGeneral.svelte";

  enum LeadPage {
    General = 1,
    Channels,
    Activities
  }

  export let oid: number;

  let currentTab: LeadPage = LeadPage.General; 

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == LeadPage.General}
      on:click={(_) => {
        currentTab = LeadPage.General;
      }}
    />
    {#if oid != 0}
      <Tab
        label="Recapiti"
        active={currentTab == LeadPage.Channels}
        on:click={(_) => {
          currentTab = LeadPage.Channels;
        }}
      />       
      <Tab
        label="Task"
        active={currentTab == LeadPage.Activities}
        on:click={(_) => {
          currentTab = LeadPage.Activities;
        }}
      />
    {/if}
  </Tabs>

  {#if currentTab == LeadPage.General}
    <LeadDetailPartGeneral  {oid} />
  {/if}

  {#if currentTab == LeadPage.Channels}
    <LeadDetailPartChannels />
  {/if}

  {#if currentTab == LeadPage.Activities}
    <LeadDetailPartActivities {oid} />
  {/if}
</MainLayout>
